(() => {
  if (customElements.get('scroll-to-section')) return;

  class ScrollToSection extends HTMLElement {
    constructor() {
      super();
      this.onButtonClick = this.onButtonClick.bind(this);
      this.onIntersection = this.onIntersection.bind(this);
      this.observer = null;
      this.buttons = [];
      this.targets = [];
    }

    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('[data-target-section]'));
      this.setEventListeners();
      this.initObserver();
    }

    disconnectedCallback() {
      this.removeEventListeners();
      if (this.observer) this.observer.disconnect();
    }

    setEventListeners() {
      this.buttons.forEach((btn) => {
        btn.addEventListener('click', this.onButtonClick);
      });
    }

    removeEventListeners() {
      this.buttons.forEach((btn) => {
        btn.removeEventListener('click', this.onButtonClick);
      });
    }

    onButtonClick(event) {
      const button = event.currentTarget;
      const sectionId = button.dataset.targetSection;
      if (!sectionId) return;

      const target = document.getElementById(sectionId);
      if (!target) return;

      this.setActive(button);
      const headerHeight = this.getHeaderOffset();
      const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    }

    setActive(activeButton) {
      this.buttons.forEach((btn) => {
        btn.setAttribute('aria-current', btn === activeButton ? 'true' : 'false');
      });
    }

    getHeaderOffset() {
      const value = getComputedStyle(document.documentElement)
        .getPropertyValue('--theme-sticky-header-height')
        .trim();
      return value ? parseFloat(value) : 0;
    }

    initObserver() {
      const sectionIds = this.buttons
        .map((btn) => btn.dataset.targetSection)
        .filter(Boolean);

      if (!sectionIds.length || !('IntersectionObserver' in window)) return;

      this.targets = sectionIds
        .map((id) => document.getElementById(id))
        .filter(Boolean);

      if (!this.targets.length) return;

      this.observer = new IntersectionObserver(this.onIntersection, {
        rootMargin: '-20% 0px -60% 0px',
        threshold: 0,
      });

      this.targets.forEach((el) => this.observer.observe(el));
    }

    onIntersection(entries) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const sectionId = entry.target.id;
        const matchingButton = this.buttons.find(
          (btn) => btn.dataset.targetSection === sectionId
        );

        if (matchingButton) this.setActive(matchingButton);
      });
    }
  }

  customElements.define('scroll-to-section', ScrollToSection);
})();
